import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import FormInfo from '../../../components/FormInfo/FormFillSummary/FormInfo';
import { FORM_INFO_TYPES } from '../../../components/FormInfo/types';
import { vars } from '../../../reactive';
import { setFormPage } from '../../../reactive/actions';

const FormFillSummary = () => {
  const { t } = useTranslation();
  const formOptions = useForm();

  const selectedBranch = useReactiveVar(vars.currentBranch);

  const { handleSubmit } = formOptions;

  const onSubmit = () => {
    setFormPage(FORM_PAGES.FORMS_FILLED);
  };

  return (
    <FormInfo
      type={FORM_INFO_TYPES.FORM_FILL_SUMMARY}
      formOptions={formOptions}
      nextButtonText={t('submit')}
      onSubmit={handleSubmit(onSubmit)}
      previousPage={{
        onPrevious: () => {
          const newPage = FORM_PAGES.BOOKING_FORMS;
          setFormPage(newPage, 'fade-out', { shouldNavigateToLastPage: true });
        },
        animation: 'fade-out'
      }}
      branchName={selectedBranch?.name}
      privacy_policy_url={selectedBranch?.privacy_policy_url}
      terms_and_conditions_url={selectedBranch?.terms_and_conditions_url}
    />
  );
};

export default FormFillSummary;
